import React, { Component } from 'react';
import Select from 'react-select';

import services from './data';

let CategoryOptions;
class POSList extends Component {
  constructor(props) {
    super(props);
    this.state = {
      options: [],
    };
  }
  componentDidMount() {
    this.getBanks();
  }

  getBanks = () => {
    services
      .getMappedPOS()
      .then((response) => {
        const tmp = response.data.data;
        const banks = [...this.state.options];
        for (let i = 0; i < tmp.length; i++) {
          banks.push({
            value: tmp[i].bunk_card_uuid,
            label: tmp[i].name,
          });
        }
        this.setState({ options: banks });
      })
      .catch((error) => {
        console.log(error);
      });
  };
  handleChange = (selectedOption) => {
    let option = selectedOption;
    if (selectedOption == null) {
      option = { value: '', label: '' };
    }

    this.props.handleBankChange(option);
  };

  render() {
    const options = this.state.options;
    return (
      <Select
        onChange={this.handleChange}
        isClearable={true}
        options={options}
        className="select-box-container"
        classNamePrefix="raw-select"
        name="payment_mode"
        placeholder="Select POS"
        value={options.filter((obj) => obj.value === this.props.value)}
        isDisabled={this.props.disabled || false}
      />
    );
  }
}

export { POSList };
